import { FeatureDefinition } from '../entities';

export const palmPolicyFeature = 'appnebula_palm_policy';

export type PalmPolicyFeatureValue = {
  text: string;
  policy: string;
  isActive: boolean;
};

export const palmPolicyDefaultValue: PalmPolicyFeatureValue = {
  text: 'We take your privacy seriously. We use your palm photo to create your palm reading. See our ',
  policy: 'Privacy Policy',
  isActive: true,
};

export const palmPolicyFeatureConfig: FeatureDefinition<PalmPolicyFeatureValue> = {
  defaultValue: palmPolicyDefaultValue,
};
